<template>
    <div>
        <header
            class="fixed top-0 left-0 right-0 z-[100] bg-white/70 dark:bg-background-dark/70 backdrop-blur-xl border-b border-gray-100 dark:border-gray-800/50">
            <nav class="max-w-[1440px] mx-auto px-8 h-24 flex items-center justify-between">
                <RouterLink to="/" class="flex items-center group">
                    <img src="/favicon.png" alt="AGSOFT"
                        class="h-32 w-auto object-contain group-hover:scale-105 transition-transform" />
                </RouterLink>
                <div class="flex items-center gap-10">
                    <div class="hidden md:flex items-center gap-8">
                        <RouterLink class="nav-link" to="/">Inicio</RouterLink>
                        <RouterLink class="nav-link" to="/servicios">Servicios</RouterLink>
                        <RouterLink class="nav-link" to="/por-que-nosotros">Por qué nosotros</RouterLink>
                        <RouterLink class="nav-link" to="/contacto">Contacto</RouterLink>
                    </div>
                    <button @click="toggleDarkMode"
                        class="p-2 rounded-lg bg-slate-200 dark:bg-slate-800 text-slate-800 dark:text-yellow-400 transition-colors flex items-center gap-2">
                        <!-- Icono dinámico con Material Symbols -->
                        <span class="material-symbols-outlined">
                            {{ isDark ? 'light_mode' : 'dark_mode' }}
                        </span>

                    </button>
                    <RouterLink to="/contacto"
                        class="bg-primary text-white text-sm font-bold px-7 py-3 rounded-full hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/25 transition-all active:scale-95">
                        Solicitar asesoría
                    </RouterLink>
                </div>
            </nav>
        </header>
    </div>
</template>

<script setup>
import { RouterLink } from 'vue-router';
import { ref, onMounted } from 'vue'

const isDark = ref(false)

// Al cargar la página, revisamos si el usuario ya tenía una preferencia guardada
onMounted(() => {
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        isDark.value = true
        document.documentElement.classList.add('dark')
    } else {
        isDark.value = false
        document.documentElement.classList.remove('dark')
    }
})


// Función para cambiar de modo al hacer clic en el botón
const toggleDarkMode = () => {
    isDark.value = !isDark.value

    if (isDark.value) {
        document.documentElement.classList.add('dark')
        localStorage.theme = 'dark'
    } else {
        document.documentElement.classList.remove('dark')
        localStorage.theme = 'light'
    }
}
</script>

<style scoped>
.nav-link {
    font-size: 0.875rem;
    font-weight: 600;
    color: rgb(71 85 105);
    transition: color 180ms ease;
}

.nav-link:hover {
    color: var(--color-primary, #0ea5e9);
}

.nav-link.router-link-active {
    color: var(--color-primary, #0ea5e9);
}

:global(.dark) .nav-link {
    color: rgb(156 163 175);
}

:global(.dark) .nav-link:hover,
:global(.dark) .nav-link.router-link-active {
    color: rgb(255 255 255);
}
</style>
